export function filterPayoutRows(rows, search) {
  const q = search.trim().toLowerCase();
  if (!q) return rows;
  return rows.filter((r) => {
    const reference = String(r?.reference ?? "").toLowerCase();
    const method = String(r?.methodLabel ?? "").toLowerCase();
    const date = String(r?.dateLabel ?? "").toLowerCase();
    return reference.includes(q) || method.includes(q) || date.includes(q);
  });
}

export function paginateSlice(items, page, pageSize) {
  const safePage = Math.max(1, page);
  const start = (safePage - 1) * pageSize;
  return items.slice(start, start + pageSize);
}

export function totalPagesFor(itemsLength, pageSize) {
  return Math.max(1, Math.ceil(itemsLength / pageSize));
}

function formatPayoutDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-US", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

function titleCase(input) {
  return String(input ?? "")
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

function buildMethodLabel(item) {
  const description = String(item?.description ?? "").trim();
  if (description) return description;
  const gateway = titleCase(item?.gateway);
  const action = titleCase(item?.action);
  const type = titleCase(item?.type);
  return [gateway, action || type].filter(Boolean).join(" — ") || "—";
}

/**
 * Map a `fetchDefaultWalletHistories` item to the row shape consumed by
 * `PayoutHistoryTable`. Amounts come from the API as dollars and are stored
 * as cents so `formatWalletAmount` keeps working.
 */
export function mapWalletHistoryItemToRow(item) {
  if (!item) return null;
  const id = item._id != null ? String(item._id) : "";
  const ref = item.reference != null ? String(item.reference) : id;
  const amountDollars = Number(item.amount);
  const amountCents = Number.isFinite(amountDollars)
    ? Math.round(amountDollars * 100)
    : 0;
  const dateSource = item.paidAt ?? item.createdAt ?? item.updatedAt ?? null;

  return {
    id,
    dateLabel: formatPayoutDate(dateSource),
    reference: ref || "—",
    amountCents,
    methodLabel: buildMethodLabel(item),
    status: String(item.status ?? "").toLowerCase(),
    raw: item,
  };
}
